import { Divider, Typography, Link as MuiLink, Button, Stack, Paper } from "@mui/material"
import { Link } from "react-router-dom"
import { LoginFooter } from "./footer"

export const Conditions = () => {
  return (
    <>
      <Divider />

      <Typography variant="body2">
      УВЕДОМЛЕНИЕ О КОНФИДЕНЦИАЛЬНОСТИ: Настоящее сообщение электронной почты
      и любые приложения к нему предназначены исключительно для указанного в нем адресата, носят информационный характер, не являются предложением о заключении соглашения
      о ведении переговоров либо согласием на его заключение или предложением о заключении договора (офертой), а также не могут быть расценены как акцепт на какое-либо предложение
      о заключении договора и не создают каких-либо обязательств для отправителя, в том числе
      не содержат каких-либо гарантий и/или заверений об обстоятельствах, имеющих значение
      для заключения договора, его исполнения или прекращения.
      </Typography>

      <Typography variant="body2">
      Это электронное сообщение и любые документы, приложенные к нему, содержат конфиденциальную информацию.
      </Typography>

      <Typography variant="body2">
      В случае, если Вы не являетесь указанным адресатом и получили настоящее сообщение
      по ошибке, просьба уведомить нас об этом ответным электронным сообщением
      и незамедлительно уничтожить полученное сообщение со всеми приложениями,
      а также не раскрывать его содержание, не копировать и не распространять его.
      </Typography>

      <Typography variant="body2">
      CONFIDENTIALITY NOTICE: This message and any files attached hereto are intended solely for the use of the addressee for informational purposes and are not an offer, advice, advertisement, warranty, representation or recommendation nor an official confirmation of any transaction. All information herein shall be treated as opinion and no obligation is created by, and no liability is accepted for loss arising from, this message. This email and any files attached hereto contains confidential information. If you are not an intended recipient, please notify the sender, delete this e-mail and do not use, disclose, copy, distribute or rely on the e-mail in any manner.
      </Typography>

      <Link to="/"><MuiLink>Дополнительная информация</MuiLink></Link>
    </>
  )
}

export const Confirmed = ({ email }: { email?: string }) => {
  return (
    <Stack maxWidth="816px" padding="3rem" spacing={2}>
      <Typography variant="h1">Ваш аккаунт подтвержден!</Typography>
      
      <Typography>Если вы открывали зашифрованное письмо, откройте его снова.</Typography>

      <LoginFooter />
    </Stack>
  )
}

export const NotFound = ({ email }: { email?: string }) => {
  return (
    <Stack maxWidth="816px" padding="3rem" spacing={2}>
      <Typography variant="h1">404 Ошибка!</Typography>
      
      <Typography>Страница по указанному адресу не найдена!</Typography>

      <Stack alignItems="center">
        <Button href="/" size="large" type="submit">Перейти на главную</Button>
      </Stack>

      <LoginFooter />
    </Stack>
  )
}

export const ErrorPage = () => {
  return (
    <Stack maxWidth="816px" padding="3rem" spacing={2}>
      <Typography variant="h1">Ошибка</Typography>
      
      <Typography>У вас нет прав для просмотра этого письма.</Typography>

      <Stack alignItems="center">
        <Button href="/" size="large" type="submit">Написать письмо</Button>
      </Stack>

      <LoginFooter />
    </Stack>
  )
}

export const Example = ({ email }: { email?: string }) => {
  return (
    <Paper sx={{ margin: "0 auto" }}>
      <Stack maxWidth="816px" padding="3rem" spacing={2}>
        <Typography variant="h1">Заголовок</Typography>
        
        <Typography>Текст.</Typography>

        <MuiLink href="/link">Ссылка</MuiLink>

        <Button href="/link">Кнопка</Button>
      </Stack>
    </Paper>
  )
}
